"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBCard", {
  enumerable: true,
  get: function get() {
    return _src.default;
  }
});
var _src = _interopRequireDefault(require("./src"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }